import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rpp-edit" }
const _hoisted_2 = { class: "flex items-center justify-between mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = { class: "mt-3 flex items-center" }
const _hoisted_5 = { class: "flex justify-end items-center mt-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование РПП" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editRPP && _ctx.editRPP(...args)), ["prevent"])),
      class: "mt-6 bg-white border px-6 py-4"
    }, [
      _createVNode(_component_the_input, {
        value: _ctx.state.act_number,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.act_number) = $event)),
        "is-invalid": _ctx.state_form$.act_number.$error,
        "validation-errors": _ctx.state_form$.act_number.$errors,
        placeholder: "Номер АВР",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.act_date,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.act_date) = $event)),
        "is-invalid": _ctx.state_form$.act_date.$error,
        "validation-errors": _ctx.state_form$.act_date.$errors,
        placeholder: "Дата АВР",
        type: "date",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.pbs_date,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pbs_date) = $event)),
        "is-invalid": _ctx.state_form$.pbs_date.$error,
        "validation-errors": _ctx.state_form$.pbs_date.$errors,
        placeholder: "Дата РПП",
        type: "date",
        class: "mt-3"
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_select, {
        placeholder: "Статья ДДС",
        "is-invalid": _ctx.state_form$.cash_flow_id.$error,
        "validation-errors": _ctx.state_form$.cash_flow_id.$errors,
        loading: _ctx.data_state.cash_flows.is_loading,
        failed: _ctx.data_state.cash_flows.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.cash_flows.list,
        value: _ctx.state.cash_flow_id,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.cash_flow_id) = $event)),
        "infinite-scroll": "",
        searchable: false,
        onRefresh: _ctx.loadCashFlows,
        class: "mt-3"
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Компания",
        loading: _ctx.data_state.carriers.is_loading,
        failed: _ctx.data_state.carriers.is_failed,
        "is-invalid": _ctx.state_form$.company_id.$error,
        "validation-errors": _ctx.state_form$.company_id.$errors,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.carriers.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
        onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
        onSearch: _ctx.searchCarriers,
        onOptionBySearch: _ctx.unshiftFindedCarrier
      }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onSearch", "onOptionBySearch"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_checkbox, {
          label: "Добавить КПН (6%)",
          value: _ctx.state.with_income_tax,
          "onUpdate:value": [
            _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.with_income_tax) = $event)),
            _ctx.onChangeTax
          ]
        }, null, 8, ["value", "onUpdate:value"]),
        (_ctx.state.with_income_tax)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 0,
              label: "Добавить 12%",
              class: "ml-3",
              value: _ctx.state.with_nds_tax,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.with_nds_tax) = $event)),
              "return-integer": ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Редактировать ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}